import {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {login, reset} from '../features/auth/authSlice'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import Spinner from '../components/Spinner' 
import {Link} from 'react-router-dom'
import {FaBuilding} from 'react-icons/fa'
import Button from '../components/ui/Button'

function Login (){
    //defaults
    const [formData, setFormData] = useState({
        email:'',
        password:'',
    }) 

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {email, password} = formData

    const onChange = (e) =>{
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]:e.target.value,
        }) )
    }


    const {user, isError, isSuccess, isLoading, message} = useSelector(state => state.auth)

    useEffect(()=>{
        if(isError){
            
            toast.error(message)
        }
        if(isSuccess || user){
             
            navigate('/homedash')
            
        }

        dispatch(reset())

    },[isError,isSuccess,user,message,navigate,dispatch])


    const onSubmit = (e)=>{
        e.preventDefault()

        const userData = {
            //comes from form data Ln 17
            email,
            password,
        }
        dispatch(login(userData))
    }

  
    if(isLoading){
        return <Spinner/>
    }
    return(
    <>
        <div className="min-h-screen bg-bg flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="hidden lg:flex flex-col items-center justify-center">
                    <h1 className="text-5xl font-semibold text-ink">TIMESTAT</h1>
                    <p className="mt-4 text-xl text-ink-2">Fraud-free jobsite attendance tracking</p>
                </div>

                <div className="max-w-md w-full mx-auto lg:mx-0 space-y-8 bg-surface p-8 rounded-xl border border-border shadow-sm">
                    <div>
                        <FaBuilding className="mx-auto h-12 w-auto text-ink-3"/>
                        <h2 className="mt-4 text-center text-4xl font-semibold text-ink">
                            Business Login
                        </h2>
                    </div>

                    <form className="mt-8 space-y-4" onSubmit={onSubmit}>
                        <input type="hidden" name="remember" value="true" />
                        <div className="space-y-3">
                            <div>
                                <label htmlFor="email" className="sr-only">Email address</label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    value={email}
                                    onChange={onChange}
                                    required
                                    className="w-full rounded-md border border-border bg-surface px-3 py-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40"
                                    placeholder="Email address"
                                />
                            </div>
                            <div>
                                <label htmlFor="password" className="sr-only">Password</label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    value={password}
                                    onChange={onChange}
                                    required
                                    className="w-full rounded-md border border-border bg-surface px-3 py-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40"
                                    placeholder="Password"
                                />
                            </div>
                        </div>

                        <div>
                            <Button type="submit" className="w-full text-base">
                                Log In
                            </Button>
                        </div>
                    </form>

                    <div className="mt-6 text-center">
                        <Link to="/resetPassword" className="underline p-2 rounded-md">
                            Forgot Password?
                        </Link>
                    </div>

                    <div className='flex justify-center'>
                        <Link to="/register" className="w-full flex justify-center">
                            <Button type="button" variant="outline" className="w-full">
                                Register
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default Login
